import {
  ApolloClient,
  InMemoryCache,
  HttpLink,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

const getClient = async (token) => {
  const cache = new InMemoryCache({
    typePolicies: {
      SmsChannelConnection: {
        keyFields: ['totalCount'],
      },
      SmsChannel: {
        keyFields: ['id'],
      },
      ChannelInteraction: {
        keyFields: ['id'],
      },
      ChannelInteractionConnection: {
        fields: {
          edges: {
            keyFields: ['cursor'],
          },
        },
      },
    },
  });

  const httpLink = new HttpLink({
    uri: process.env.REACT_APP_API_ENDPOINT,
  });

  const authLink = setContext((_, { headers }) => ({
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  }));

  const link = authLink.concat(httpLink);

  const client = new ApolloClient({
    link,
    cache,
  });

  return client;
};

export default getClient;
